import { create } from "zustand";
import { Product } from "../types";

// interface FavoriteItem {
//   product_id: number;
//   name: string;
//   price: number;
// }

interface FavoritesStore {
  items: Product[];
  addItem: (item: Product) => void;
  removeItem: (productId: number) => void;
  setItems: (items: Product[]) => void;
  clearFavorites: () => void;
}

export const useFavoritesStore = create<FavoritesStore>((set) => ({
  items: JSON.parse(localStorage.getItem("favorites") || "[]"),
  
  setItems: (items) => {
    localStorage.setItem("favorites", JSON.stringify(items));
    set({ items });
  },

  addItem: (item) =>
    set((state) => {
      const exists = state.items.find((i) => i.id === item.id);
      if (!exists) {
        const updated = [...state.items, item];
        localStorage.setItem("favorites", JSON.stringify(updated));
        return { items: updated };
      }
      return state; // Если уже есть, то не меняем состояние
    }),

  removeItem: (productId) =>
    set((state) => {
      const updated = state.items.filter((i) => i.id !== productId);
      localStorage.setItem("favorites", JSON.stringify(updated));
      return { items: updated };
    }),

  clearFavorites: () => {
    localStorage.removeItem("favorites");
    set({ items: [] });
  },
}));
